import Icon from '../components/Icon.vue'

Icon.register({"viacoin":{"width":1536,"height":1792,"paths":[{"d":"M1536 0l-192 448h192v192h-274l-55 128h329v192h-411l-357 832-357-832h-411v-192h329l-55-128h-274v-192h192l-192-448h256l323 768h378l323-768h256zM768 1216l108-256h-216z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/viacoin.js
// module id = 1225
// module chunks = 0